"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.State = exports.ReceiptList = exports.ReceiptEntry = exports.Receipt = void 0;
const buffer_1 = require("../common/buffer");
const encoding_1 = require("../encoding");
class Receipt {
    constructor(args) {
        this.start =
            args.start == undefined
                ? undefined
                : args.start instanceof Uint8Array
                    ? args.start
                    : buffer_1.Buffer.from(args.start, "hex");
        this.startIndex = args.startIndex == undefined ? undefined : args.startIndex;
        this.end =
            args.end == undefined
                ? undefined
                : args.end instanceof Uint8Array
                    ? args.end
                    : buffer_1.Buffer.from(args.end, "hex");
        this.endIndex = args.endIndex == undefined ? undefined : args.endIndex;
        this.anchor =
            args.anchor == undefined
                ? undefined
                : args.anchor instanceof Uint8Array
                    ? args.anchor
                    : buffer_1.Buffer.from(args.anchor, "hex");
        this.entries =
            args.entries == undefined
                ? undefined
                : args.entries.map((v) => v == undefined ? undefined : v instanceof ReceiptEntry ? v : new ReceiptEntry(v));
    }
    copy() {
        return new Receipt(this.asObject());
    }
    asObject() {
        return {
            start: this.start && this.start && buffer_1.Buffer.from(this.start).toString("hex"),
            startIndex: this.startIndex && this.startIndex,
            end: this.end && this.end && buffer_1.Buffer.from(this.end).toString("hex"),
            endIndex: this.endIndex && this.endIndex,
            anchor: this.anchor && this.anchor && buffer_1.Buffer.from(this.anchor).toString("hex"),
            entries: this.entries && this.entries?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).bytes
], Receipt.prototype, "start", void 0);
__decorate([
    encoding_1.encodeAs.field(2).int
], Receipt.prototype, "startIndex", void 0);
__decorate([
    encoding_1.encodeAs.field(3).bytes
], Receipt.prototype, "end", void 0);
__decorate([
    encoding_1.encodeAs.field(4).int
], Receipt.prototype, "endIndex", void 0);
__decorate([
    encoding_1.encodeAs.field(5).bytes
], Receipt.prototype, "anchor", void 0);
__decorate([
    encoding_1.encodeAs.field(6).repeatable.reference
], Receipt.prototype, "entries", void 0);
exports.Receipt = Receipt;
class ReceiptEntry {
    constructor(args) {
        this.right = args.right == undefined ? undefined : args.right;
        this.hash =
            args.hash == undefined
                ? undefined
                : args.hash instanceof Uint8Array
                    ? args.hash
                    : buffer_1.Buffer.from(args.hash, "hex");
    }
    copy() {
        return new ReceiptEntry(this.asObject());
    }
    asObject() {
        return {
            right: this.right && this.right,
            hash: this.hash && this.hash && buffer_1.Buffer.from(this.hash).toString("hex"),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).bool
], ReceiptEntry.prototype, "right", void 0);
__decorate([
    encoding_1.encodeAs.field(2).bytes
], ReceiptEntry.prototype, "hash", void 0);
exports.ReceiptEntry = ReceiptEntry;
class ReceiptList {
    constructor(args) {
        this.merkleState =
            args.merkleState == undefined
                ? undefined
                : args.merkleState instanceof State
                    ? args.merkleState
                    : new State(args.merkleState);
        this.elements =
            args.elements == undefined
                ? undefined
                : args.elements.map((v) => v == undefined ? undefined : v instanceof Uint8Array ? v : buffer_1.Buffer.from(v, "hex"));
        this.receipt =
            args.receipt == undefined
                ? undefined
                : args.receipt instanceof Receipt
                    ? args.receipt
                    : new Receipt(args.receipt);
        this.continuedReceipt =
            args.continuedReceipt == undefined
                ? undefined
                : args.continuedReceipt instanceof Receipt
                    ? args.continuedReceipt
                    : new Receipt(args.continuedReceipt);
    }
    copy() {
        return new ReceiptList(this.asObject());
    }
    asObject() {
        return {
            merkleState: this.merkleState && this.merkleState.asObject(),
            elements: this.elements &&
                this.elements?.map((v) => v == undefined ? undefined : v && buffer_1.Buffer.from(v).toString("hex")),
            receipt: this.receipt && this.receipt.asObject(),
            continuedReceipt: this.continuedReceipt && this.continuedReceipt.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).reference
], ReceiptList.prototype, "merkleState", void 0);
__decorate([
    encoding_1.encodeAs.field(2).repeatable.bytes
], ReceiptList.prototype, "elements", void 0);
__decorate([
    encoding_1.encodeAs.field(3).reference
], ReceiptList.prototype, "receipt", void 0);
__decorate([
    encoding_1.encodeAs.field(4).reference
], ReceiptList.prototype, "continuedReceipt", void 0);
exports.ReceiptList = ReceiptList;
class State {
    constructor(args) {
        this.count = args.count == undefined ? undefined : args.count;
        this.pending =
            args.pending == undefined
                ? undefined
                : args.pending.map((v) => v == undefined ? undefined : v instanceof Uint8Array ? v : buffer_1.Buffer.from(v, "hex"));
        this.hashList =
            args.hashList == undefined
                ? undefined
                : args.hashList.map((v) => v == undefined ? undefined : v instanceof Uint8Array ? v : buffer_1.Buffer.from(v, "hex"));
    }
    copy() {
        return new State(this.asObject());
    }
    asObject() {
        return {
            count: this.count && this.count,
            pending: this.pending &&
                this.pending?.map((v) => v == undefined ? undefined : v && buffer_1.Buffer.from(v).toString("hex")),
            hashList: this.hashList &&
                this.hashList?.map((v) => v == undefined ? undefined : v && buffer_1.Buffer.from(v).toString("hex")),
        };
    }
}
exports.State = State;
//# sourceMappingURL=types_gen.js.map